import { LegalShell } from './LegalPages';
import content from '../data/terms-content.json';
export default function TermsPage() {
  return <LegalShell testid="terms-of-use" title="Terms of Use" intro="The terms that apply when you use The Standard website and its reader services.">
    {content.map((item,i)=>item.tag==='p'?<p key={i} className="mb-6 leading-[1.6] text-[var(--muted)]">{item.text}</p>:<h2 key={i} className="font-display text-2xl mt-8 mb-4">{item.text}</h2>)}
  </LegalShell>;
}
